import { httpStatusCodes } from '@common/Constants';
import Logger from '@common/Logger.js';
import baseService, {
  getBaseUrl,
  getBaseHeaders,
  getFormHeaders,
  getBaseTEMUrl
} from '@services/baseService';

export const getAxiosConfiguration = (path, temApi = false, auth) => {
  const urlPart = temApi
    ? path
      ? getBaseTEMUrl() + path
      : getBaseTEMUrl()
    : path
      ? getBaseUrl() + path
      : getBaseUrl();

  return {
    url: urlPart,
    method: 'GET',
    headers: getBaseHeaders(auth)
  };
};

export const getService = async (path, callBackError = null, temApi, auth = true) => {
  try {
    return await baseService(getAxiosConfiguration(path, temApi, auth));
  } catch (error) {
    Logger.error(error);
    if (callBackError) {
      callBackError(error);
    }
  }
};

export const getServiceByConfig = async (config, callBackError = null) => {
  try {
    return await baseService(config);
  } catch (error) {
    Logger.error(error);
    if (callBackError) {
      callBackError(error);
    }
  }
};

export const getServiceWithCallback = async (config, callbackSuccess, callbackError) => {
  try {
    const response = await baseService(config);
    if (response?.status === httpStatusCodes.ok) {
      if (callbackSuccess) {
        callbackSuccess(response);
      }
    }
  } catch (error) {
    if (callbackError) {
      callbackError(error);
    }
    Logger.error(error);
  }
};

export const uploadAxiosConfiguration = (path, data) => {
  const urlPart = path ? getBaseUrl() + path : getBaseUrl();

  return {
    url: urlPart,
    method: 'POST',
    headers: getFormHeaders(),
    data: data
  };
};

export const uploadService = async (path, data) => {
  try {
    return await baseService(uploadAxiosConfiguration(path, data));
  } catch (error) {
    Logger.error(error);
  }
};

export const postAxiosConfiguration = (path, data) => {
  const urlPart = path ? getBaseUrl() + path : getBaseUrl();

  return {
    url: urlPart,
    method: 'POST',
    headers: getBaseHeaders(),
    data: data
  };
};

export const postService = async (path, data) => {
  try {
    return await baseService(postAxiosConfiguration(path, data));
  } catch (error) {
    Logger.error(error);
  }
};

export const patchAxiosConfiguration = (path, data) => {
  const urlPart = path ? getBaseUrl() + path : getBaseUrl();

  return {
    url: urlPart,
    method: 'PATCH',
    headers: getBaseHeaders(),
    data: data
  };
};

export const patchService = async (path, data, callBackError = null) => {
  try {
    return await baseService(patchAxiosConfiguration(path, data));
  } catch (error) {
    Logger.error(error);
    if (callBackError) {
      callBackError(error);
    }
  }
};

export const deleteAxiosConfiguration = (path) => {
  const urlPart = path ? getBaseUrl() + path : getBaseUrl();

  return {
    url: urlPart,
    method: 'DELETE',
    headers: getBaseHeaders()
  };
};

export const deleteService = async (path, callBackError = null) => {
  try {
    return await baseService(deleteAxiosConfiguration(path));
  } catch (error) {
    Logger.error(error);
    if (callBackError) {
      callBackError(error);
    }
  }
};
